import type { LocalIssueId } from '@atlassian/jira-polaris-domain-idea/src/idea/types.tsx';
import { createGetBucketFilteredIssueIds } from './bucket.tsx';
import { createHigherLevelIssueHook } from './utils.tsx';

export const useBucketFilteredIssueIds = createHigherLevelIssueHook<string, LocalIssueId[]>(
	createGetBucketFilteredIssueIds,
);
